import React from 'react';

const HomePageConfig: any = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/home',
			exact: true,
			component: React.lazy(() => import('./HomePage')),
		},
	],
};

export default HomePageConfig;
